import { modalBackdropTheme } from './atoms/modal-backdrop-theme';
import { modalBackdropStyles } from './atoms/modal-backdrop.styles';
import { fullscreenModalHeaderTheme } from './fullscreen-modal/fullscreen-modal-header-theme';
import { fullscreenModalHeaderStyle } from './fullscreen-modal/fullscreen-modal-header.styles';

export const ModalStyles = {
  fullscreenModalHeader: fullscreenModalHeaderStyle(fullscreenModalHeaderTheme),
  modalBackdropStyles: modalBackdropStyles(modalBackdropTheme),
};
